var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.contact",
  title: "EGT Contact page",
  description: "On-brand contact page; reuses the existing verified-contact client (/src/contact-us.js).",
  supportServer: true
});
var S = require("../helpers/egt.sections.js");

/* The verified-contact client (/src/contact-us.js) depends on these EXACT ids /
 * field names — DO NOT rename: #contact-us-form, #contact-us-status,
 * #contact-us-submit, and the field names email / firstname / lastname /
 * phone / howcanwehelp. The layout below is a calm frosted-glass split
 * (editorial left, platform-control form right on a wide dark glass card) on
 * the warm About canvas image — media is UNDIMMED; contrast comes from the
 * glass card only (house rule: never a scrim on the art). */

function trustLine(icon, text) {
  return {
    n: "li", c: "egt-contact__trust-item",
    i: [
      { n: "i", c: icon + " egt-contact__trust-icon", "aria-hidden": "true" },
      { n: "span", i: text }
    ]
  };
}

exports.render = async function render() {
  var editorial = {
    n: "div", c: "egt-contact__editorial",
    i: [
      { n: "p", c: "egt__eyebrow egt-reveal", i: "Contact" },
      { n: "h1", c: "egt-contact__title egt-reveal",
        i: [ "Tell us what ", { n: "br" }, "you're ", { n: "span", c: "egt__gold", i: "building." } ] },
      { n: "p", c: "egt-contact__lead egt-reveal",
        i: "New business, press, or a question — send it here. No phone trees, no forms-into-the-void." },
      { n: "ul", c: "egt-contact__trust egt-reveal", style: "--egt-i:1",
        i: [
          trustLine("bi-clock-history", "We reply within one business day."),
          trustLine("bi-shield-lock", "We verify your email, then it comes straight to us — nothing is shared.")
        ] },
      { n: "p", c: "egt-contact__forge-link egt-reveal", style: "--egt-i:2",
        i: [
          "Submitting a project request? ",
          { n: "a", href: "/forge/start", c: "egt-contact__forge-cta",
            i: [ "Start here", { n: "span", c: "egt-cta__tick", i: " →" } ] }
        ] }
    ]
  };

  var formCard = S.glass({
    width: "wide", tone: "dark", c: "egt-contact__card egt-reveal",
    content: [
      { n: "div", id: "contact-us-status", class: "egt-contact__status d-none", role: "status", "aria-live": "polite", tabindex: "-1", i: "" },
      { n: "div", id: "contact-us-form", class: "egt-form egt-contact__form",
        i: { n: "div",
          i: [
            { n: "div", c: "row", i: { n: "div", c: "col-12", i: {
              n: "ua.input", title: "Your email address", icon: "bi-envelope", name: "email", class: "pt-3",
              required: true, autocomplete: "email", placeholder: "you@example.com", type: "email" } } },
            { n: "div", c: "row", i: [
              { n: "div", c: "col-12 col-lg-6", i: {
                n: "ua.input", title: "First name", name: "firstname", placeholder: "Jordan", class: "pt-3",
                required: true, icon: "bi-file-person", minlength: "2", maxlength: "128", type: "text" } },
              { n: "div", c: "col-12 col-lg-6", i: {
                n: "ua.input", title: "Last name", name: "lastname", placeholder: "Avery", class: "pt-3",
                required: true, icon: "bi-file-person", minlength: "2", maxlength: "128", type: "text" } }
            ] },
            { n: "div", c: "row", i: { n: "div", c: "col-12", i: {
              n: "ua.phone", title: "Phone (optional)", icon: "bi-telephone", name: "phone", class: "pt-3",
              required: false, autocomplete: "tel", placeholder: "+16140000009", international: false } } },
            { n: "div", c: "row", i: { n: "div", c: "col-12", i: {
              n: "ua.doc.simple", title: "How can we help?", name: "howcanwehelp", class: "pt-3", required: true } } }
          ] } },
      { n: "p", c: "egt-contact__consent-note", i: [
        "One more step protects us both: before we send, you'll verify your email and agree to the ",
        { n: "a", href: "/legal/codex", target: "_blank", rel: "noopener", c: "egt-contact__codex-link",
          i: "EGT Codex" },
        " (our Terms & Privacy)." ] },
      { n: "div", class: "pt-4", id: "contact-us-submit-row",
        i: { n: "button", id: "contact-us-submit", type: "button", c: "egt-cta",
          i: [ "Send message", { n: "span", c: "egt-cta__tick", i: "›" } ] } }
    ]
  });

  return S.page("/reserve", [
    { n: "section", c: "egt-section egt-canvas egt-canvas--center egt-contact",
      i: [
        S.media({ img: "/imgs/egt-about-canvas.jpg", alt: "", parallax: 0.08 }),
        { n: "div", c: "egt__shell egt-canvas__inner egt-contact__inner",
          i: [ editorial, formCard ] }
      ] },
    /* JSON-LD: ContactPage + BreadcrumbList (SEO wave 2B-7) */
    S.pageSchema({ path: "/contact-us", name: "Contact EGT", type: "ContactPage", about: "/#organization",
      crumbs: [ { name: "Contact" } ] })
  ]);
};
